"use strict";

var Backbone = require('backbone');

var AppointmentModel = Backbone.Model.extend({
  /*
   * Holds the appointment information, ie the
   * array of appointment choices, and the value
   * of the selected appointment
   */
  validate: function() {
    if (this.get('selected_appointment')) return;
    return 'invalid';
  }
});

module.exports = AppointmentModel;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/arrival/models/appointmentmodel.js
 **/